import React, { useEffect, useRef } from 'react';
import TickerEventCard from './TickerEventCard';
import { sortTickerEvents, isPostMatchEntry } from '../../utils/tickerUtils';

export default function TickerFeed({ events, onDelete, onUpdate, gameFinished, compact = true, lastCreatedId }) {
    const topRef = useRef(null);
    const prevLen = useRef(events.length);

    useEffect(() => {
        if (events.length > prevLen.current && topRef.current) {
            topRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        prevLen.current = events.length;
    }, [events.length]);

    const sorted = sortTickerEvents(events);

    if (sorted.length === 0) {
        return (
            <div className="ticker-empty">
                <div className="ticker-empty-icon">📡</div>
                <p className="font-medium text-slate-400">Noch keine Meldungen</p>
                <p className="text-sm mt-1 text-slate-600">Tippe unten oder nutze die Buttons oben</p>
            </div>
        );
    }

    return (
        <div>
            <div ref={topRef} />
            {sorted.map((event) => (
                <TickerEventCard
                    key={event._id}
                    event={event}
                    onDelete={onDelete}
                    onUpdate={onUpdate}
                    hideMinute={isPostMatchEntry(event, gameFinished)}
                    compact={compact && !gameFinished}
                    isNew={event._id === lastCreatedId}
                />
            ))}
        </div>
    );
}
